module.exports = __webpack_public_path__ + "img/product_117.58b93ca.webp";